import { Outlet, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';
import WikiSidebar from './WikiSidebar';
import WikiSearchBar from './WikiSearchBar';
import LangToggle from './LangToggle';
import { LogOut, User, Menu, X } from 'lucide-react';
import { useState } from 'react';

export default function WikiLayout() {
    const { user, logout, loading } = useAuth();
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    if (loading) {
        return <div className="loading"><div className="spinner" />Loading...</div>;
    }

    return (
        <div style={{ display: 'flex', height: '100vh', background: 'var(--bg-primary)', overflow: 'hidden' }}>
            {/* Mobile sidebar toggle */}
            <button
                onClick={() => setSidebarOpen(!sidebarOpen)}
                style={{
                    display: 'none',
                    position: 'fixed',
                    top: '0.75rem',
                    left: '0.75rem',
                    zIndex: 50,
                    background: 'var(--bg-secondary)',
                    border: '1px solid var(--border)',
                    borderRadius: '4px',
                    color: 'var(--gold)',
                    padding: '0.5rem',
                    cursor: 'pointer',
                }}
                className="mobile-sidebar-toggle"
            >
                {sidebarOpen ? <X size={20} /> : <Menu size={20} />}
            </button>

            {/* Sidebar — visible on desktop, toggleable on mobile */}
            <div
                style={{
                    display: sidebarOpen ? 'flex' : 'none',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    zIndex: 40,
                }}
                onClick={() => setSidebarOpen(false)}
            >
                <WikiSidebar />
            </div>

            {/* Main area */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                {/* Top bar */}
                <div style={{
                    background: 'var(--bg-secondary)',
                    borderBottom: '1px solid var(--border)',
                    padding: '0.5rem 1rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem',
                    minHeight: '48px',
                }}>
                    <WikiSearchBar />

                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                        <Link to="/" style={{ color: 'var(--text-secondary)', fontSize: '0.75rem', textDecoration: 'none' }}>
                            → Cases
                        </Link>

                        <LangToggle />

                        {/* User menu */}
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                position: 'relative',
                            }}
                        >
                            <User size={18} color="var(--text-secondary)" />
                            <div>
                                <div style={{ fontSize: '0.8rem', color: 'var(--text-primary)', fontWeight: 500 }}>
                                    {user?.fullname || user?.email}
                                </div>
                                <div style={{
                                    fontSize: '0.65rem',
                                    color: 'var(--gold)',
                                    background: 'var(--gold-light)',
                                    padding: '0 0.35rem',
                                    borderRadius: '2px',
                                    display: 'inline-block',
                                    textTransform: 'uppercase',
                                    fontWeight: 600,
                                }}>
                                    {user?.role || 'viewer'}
                                </div>
                            </div>
                            <button
                                onClick={handleLogout}
                                title="Logout"
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    color: 'var(--text-secondary)',
                                    cursor: 'pointer',
                                    padding: '0.25rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <LogOut size={16} />
                            </button>
                        </div>
                    </div>
                </div>

                {/* Content area */}
                <div style={{ flex: 1, overflowY: 'auto', padding: '1.5rem' }}>
                    <Outlet />
                </div>
            </div>
        </div>
    );
}